import { formatMapToOptions } from '@/utils/tool'
import type { ComposerTranslation } from 'vue-i18n'
import { WatermarkDensity } from './watermark-density'
import { WatermarkField } from './watermark-field'
import { WatermarkType } from './watermark-type'

export function getWatermarkTypeLabel (t: ComposerTranslation, type: number): string {
  const map: Partial<Record<number, string>> = {
    [WatermarkType.hidden]: t('screenWatermark.markTypeHidden'),
    [WatermarkType.visible]: t('screenWatermark.markTypeVisible'),
    [WatermarkType.custom]: t('screenWatermark.markTypeCustom'),
  }
  return map[type] ?? String(type)
}

export function getWatermarkModeLabel (t: ComposerTranslation, mode: number): string {
  return mode === 1 ? t('screenWatermark.modeGlobal') : t('screenWatermark.modeSoftware')
}

export function getWatermarkFieldLabel (t: ComposerTranslation, field: string): string {
  const keyMap: Record<string, string> = {
    [WatermarkField.user_mark]: 'screenWatermark.fieldUserMark',
    [WatermarkField.group_id]: 'screenWatermark.fieldGroupId',
    [WatermarkField.client_ip]: 'screenWatermark.fieldClientIp',
    [WatermarkField.mac]: 'screenWatermark.fieldMac',
    [WatermarkField.ctime]: 'screenWatermark.fieldCtime',
    [WatermarkField.custom_text]: 'screenWatermark.fieldCustomText',
  }
  const k = keyMap[field]
  return k ? t(k) : field
}

export function getWatermarkFieldOptions (t: ComposerTranslation) {
  const m: Record<string, string> = {
    [WatermarkField.user_mark]: t('screenWatermark.fieldUserMark'),
    [WatermarkField.group_id]: t('screenWatermark.fieldGroupId'),
    [WatermarkField.client_ip]: t('screenWatermark.fieldClientIp'),
    [WatermarkField.mac]: t('screenWatermark.fieldMac'),
    [WatermarkField.ctime]: t('screenWatermark.fieldCtime'),
    [WatermarkField.custom_text]: t('screenWatermark.fieldCustomText'),
  }
  return formatMapToOptions(m)
}

export function getWatermarkDensityOptions (t: ComposerTranslation) {
  const m: Record<number, string> = {
    [WatermarkDensity.sparse]: t('screenWatermark.densitySparse'),
    [WatermarkDensity.standard]: t('screenWatermark.densityStandard'),
    [WatermarkDensity.intensive]: t('screenWatermark.densityIntensive'),
  }
  return formatMapToOptions(m, true)
}

export function getWatermarkFieldExample (t: ComposerTranslation, field: string): string {
  const keyMap: Record<string, string> = {
    [WatermarkField.user_mark]: 'screenWatermark.exampleUserMark',
    [WatermarkField.group_id]: 'screenWatermark.exampleGroup',
    [WatermarkField.client_ip]: 'screenWatermark.exampleClientIp',
    [WatermarkField.mac]: 'screenWatermark.exampleMac',
    [WatermarkField.ctime]: 'screenWatermark.exampleCtime',
  }
  const k = keyMap[field]
  return k ? t(k) : ''
}
